import { api2 , apiUpload } from './ApiService';

export default class GameService {
    
    static async get(){
        let response =  await api2.get(`/api/v1/game`)
        return response.data
    }

     static async getWepayGames(){
        let response =  await api2.get(`/api/v1/game/wepay`)
        return response.data
    }

    static async search(key,page,perpage){
        let data ={
            searchKey: key,
            page: page,
            perpage:perpage
        }
        let response =  await api2.post(`/api/v1/game/search`,data)
        return response.data
    }
 
    static async create(formData){
        let response = await apiUpload.post(`/api/v1/game/create`,formData)
        return response.data
    }
    static async update(formData){
        let response = await apiUpload.post(`/api/v1/game/update`,formData)
        return response.data
    }
    static async delete(data){
        let response = await api2.post(`/api/v1/game/delete`,data)
        return response.data
    }
    
}


// WEBPACK FOOTER //
// ./src/service/GameService.js